import { render, staticRenderFns } from "./labs-list.vue?vue&type=template&id=715d44f6&"
import script from "./labs-list.vue?vue&type=script&lang=js&"
export * from "./labs-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\OSPanel\\domains\\specialty.local\\local\\js\\specialty\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('715d44f6')) {
      api.createRecord('715d44f6', component.options)
    } else {
      api.reload('715d44f6', component.options)
    }
    module.hot.accept("./labs-list.vue?vue&type=template&id=715d44f6&", function () {
      api.rerender('715d44f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/labs/labs-list.vue"
export default component.exports